import {Component, OnInit} from '@angular/core';
import {devices} from "../../data/devices.const";
import {devices_service} from "../../data/devices.const";
import {ChoiceService} from "../../services/choice.service";
import {Choice} from "../../models/choice.enum";
import {Device} from "../../models/device.model";
import {StepsService} from "../../services/steps.service";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-step2',
    templateUrl: './step2.component.html',
    styleUrls: ['./step2.component.scss']
})
export class Step2Component implements OnInit {

    devices = devices;
    imgUrl = environment.serverImages

    constructor(private choiceSrv: ChoiceService, private stepSrv: StepsService) {
    }

    ngOnInit(): void {

        if (this.choiceSrv.choice === Choice.service) {
            this.devices = devices_service;
        }
    }

    get selectedDeviceID(): string {
        return this.choiceSrv.selectedDevice?.id ?? 'nothing';
    }

    get headerText(): string {

        let text = ''

        if (this.choiceSrv.choice === Choice.service) {
            text = "Select the device you want to service"
        } else if (this.choiceSrv.choice === Choice.purchase) {
            text = 'Select the device, materials or parts you want to buy'
        } else {
            text = "Select the device"
        }


        return text;

    }

    selectDevice(device: Device) {
        this.choiceSrv.setDevice(device);
        this.stepSrv.nextStep();
    }

    backToPrevStep() {
        this.stepSrv.prevStep();
    }
}
